import React from 'react'

const SvgExchange = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M18.537 18H3.002c-.67 0-1.004-.333-1.002-1 .002-.666.335-1 1-1h15.467l-1.137-1.137a1 1 0 011.414-1.414l2.879 2.879a1 1 0 010 1.414l-2.88 2.88a1 1 0 11-1.414-1.414L18.536 18zM5.607 6H21c.667-.003 1 .33 1 1.002 0 .671-.333 1.004-1 .998H5.537l1.207 1.208a1 1 0 11-1.414 1.414l-2.88-2.88a1 1 0 010-1.414l2.879-2.879a1 1 0 011.414 1.414L5.606 6z'
    />
  </svg>
)

export default SvgExchange
